import React from "react";
import postLaunch from "../../assets/img/features/Post-Launch-Support.png";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { Link } from "react-router-dom";

const PostLaunchSupport = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Post-Launch Support for E-Commerce & Web Apps
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">
              Post-Launch Support for E-Commerce & Web Apps
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={postLaunch}
                    className="img-fluid rounded w-45"
                    alt="Post Launch Support"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7">
              <h1>
                Ensuring Long-Term Success with AI-Powered Maintenance & Support
              </h1>
              <p className="font-size-p">
                At [Your Company Name], we provide end-to-end post-launch
                support to keep your eCommerce store, web application, or
                API-driven platform running at peak performance. Our AI-powered
                support solutions include real-time monitoring, security
                updates, bug fixes, performance optimization, and feature
                enhancements to ensure your digital platform remains scalable,
                secure, and future-ready.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Why Choose Us Section Start */}
      <header className="sub-heading-section">
        <h1>Key Components of Our Post-Launch Support</h1>
      </header>

      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              1. 24/7 AI-Powered Monitoring & Maintenance
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>Real-Time System Health Checks
                – AI-driven tools continuously scan for performance, uptime, and
                security threats.
              </li>
              <li>
                <span className="icon-box"></span>Proactive Issue Resolution –
                AI-based predictive analytics detect and fix potential issues
                before they escalate.
              </li>
              <li>
                <span className="icon-box"></span>Downtime Prevention & Quick
                Recovery – Automatic failover systems ensure zero downtime for
                critical services.
              </li>
              <li>
                <span className="icon-box"></span>Automated Error Logging &
                Reporting – AI-powered tools log issues and notify the support
                team instantly.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              2. Security Updates & Compliance Management
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>Regular Security Patches &
                Vulnerability Fixes – Protect against DDoS attacks, malware, and
                data breaches.
              </li>
              <li>
                <span className="icon-box"></span>SSL, Firewall & Endpoint
                Security Management – Ensure data encryption and secure
                transactions.
              </li>
              <li>
                <span className="icon-box"></span>AI-Based Threat Detection –
                Monitors traffic for suspicious activities and blocks malicious
                requests.
              </li>
              <li>
                <span className="icon-box"></span>Compliance Audits – Ensure
                adherence to GDPR, PCI-DSS, HIPAA, and ISO security standards.
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              3. Performance Optimization & AI-Driven Enhancements
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>Speed Optimization – Minimize
                load times with AI-driven caching, image compression, and CDN
                integration.
              </li>
              <li>
                <span className="icon-box"></span>AI-Based Code & Database
                Optimization – Regularly refactor backend processes for faster
                query execution.
              </li>
              <li>
                <span className="icon-box"></span>Mobile & Cross-Device
                Performance Tuning – Ensure smooth experiences across Android,
                iOS, desktop, and tablets.
              </li>
              <li>
                <span className="icon-box"></span>AI-Powered User Experience
                (UX) Improvements – AI analyzes user interactions to enhance
                UI/UX design.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              4. Bug Fixes & Continuous Improvements
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>AI-Assisted Bug Detection &
                Auto-Fixes – AI pinpoints errors in real-time and suggests
                automated fixes.
              </li>
              <li>
                <span className="icon-box"></span>Version Upgrades &
                Compatibility Fixes – Keep your software, plugins, and APIs
                updated.
              </li>
              <li>
                <span className="icon-box"></span>Codebase Maintenance –
                Maintain clean, efficient, and scalable code for long-term
                stability.
              </li>
              <li>
                <span className="icon-box"></span>Error Resolution SLA – Our
                structured Service Level Agreement (SLA) ensures timely issue
                resolution.
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              5. AI-Powered Customer Support & Chatbots
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>24/7 AI Chatbot Support –
                Automate responses for common issues, FAQs, and troubleshooting.
              </li>
              <li>
                <span className="icon-box"></span>Multi-Channel Support –
                Assistance via email, live chat, WhatsApp, Slack, and ticketing
                systems.
              </li>
              <li>
                <span className="icon-box"></span>Human + AI Hybrid Support –
                Escalate complex issues to human agents while AI handles routine
                queries.
              </li>
              <li>
                <span className="icon-box"></span>AI-Powered Self-Service Help
                Center – Intelligent knowledge base with personalized
                recommendations.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              6. Feature Enhancements & Future Scalability
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>New Feature Development –
                Implement AI-driven personalization, automation, and advanced
                integrations.
              </li>
              <li>
                <span className="icon-box"></span>API & Third-Party Service
                Upgrades – Keep your integrations updated with latest API
                standards.
              </li>
              <li>
                <span className="icon-box"></span>AI-Based A/B Testing & CRO –
                Experiment with UI/UX changes to boost engagement and sales.
              </li>
              <li>
                <span className="icon-box"></span>Scalability Planning – Ensure
                your platform is ready for high-traffic loads and future
                business growth.
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <h2 className="section-title">
              7. Regular Analytics & Performance Reports
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span>AI-Powered Insights &
                Predictive Analytics – Get automated reports on traffic, sales,
                and user engagement.
              </li>
              <li>
                <span className="icon-box"></span>SEO & Digital Marketing
                Support – AI-driven keyword tracking, SEO audits, and ranking
                improvements.
              </li>
              <li>
                <span className="icon-box"></span>Custom Dashboard & KPI
                Monitoring – Track real-time metrics via Google Analytics, GA4,
                and AI-powered BI tools.
              </li>
              <li>
                <span className="icon-box"></span>Personalized Recommendations –
                AI suggests data-driven improvements for maximum ROI.
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Why Choose Us Section End */}

      {/* Pricing Section Start */}
      <div className="container py-5">
        <h2 className="text-center mb-4">Support Plan</h2>
        <div className="table-responsive">
          <table className="table table-bordered support-table">
            <thead className="table-primary">
              <tr>
                <th>Feature</th>
                <th>Basic Support</th>
                <th>Advanced Support</th>
                <th>Enterprise Support</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>AI-Powered Monitoring</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>Security Updates & Compliance</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>Performance Optimization</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>Bug Fixes & Error Resolution</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>AI Chatbot Assistance</td>
                <td>&#10008;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>Feature Enhancements & API Upgrades</td>
                <td>&#10008;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>AI-Based Analytics & Insights</td>
                <td>&#10008;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>24/7 Human Support</td>
                <td>&#10008;</td>
                <td>&#10004;</td>
                <td>&#10004;</td>
              </tr>
              <tr>
                <td>Dedicated Account Manager</td>
                <td>&#10008;</td>
                <td>&#10008;</td>
                <td>&#10004;</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="custom-plan">
          <h4>📌 Custom Plans Available</h4>
          <p className="font-size-p">
            Tailored support based on business needs.
          </p>
        </div>
        <div className="text-left mt-4">
          <h3>🚀 Future-Proof Your Platform with Our AI-Powered Support!</h3>
          <p className="font-size-p">
            A successful eCommerce store, SaaS product, or web application
            requires continuous support, security, and optimization.
          </p>
          <p className="font-size-p">
            Our AI-driven post-launch maintenance ensures maximum uptime,
            security, and business growth.
          </p>
        </div>
      </div>
      {/* Pricing Section End */}

      <div className="container">
        {/* Contact Information Start */}
        <div className="row g-4 mb-5">
          <div
            className="col-md-6 col-lg-3 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{
              visibility: "visible",
              animationDelay: "0.2s",
              animationName: "fadeInUp",
            }}
          >
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <div>
                <h4>Website</h4>
                <p className="mb-0">
                  <a href="https://epic-x.io/">epic-x.io</a>
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-3 wow fadeInUp"
            data-wow-delay="0.4s"
            style={{
              visibility: "visible",
              animationDelay: "0.4s",
              animationName: "fadeInUp",
            }}
          >
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-envelope fa-2x"></i>
              </div>
              <div>
                <h4>Mail Us</h4>
                <p className="mb-0">techsupport@epic-x.io</p>
              </div>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-3 wow fadeInUp"
            data-wow-delay="0.6s"
            style={{
              visibility: "visible",
              animationDelay: "0.6s",
              animationName: "fadeInUp",
            }}
          >
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fa fa-phone-alt fa-2x"></i>
              </div>
              <div>
                <h4>Call Us</h4>
                <p className="mb-0">+91-8925696660</p>
              </div>
            </div>
          </div>
          <h4>
            Let’s optimize, secure, and scale your platform for long-term
            success! 🚀
          </h4>
        </div>
      </div>
      {/* Contact Information End */}
      <Footer />
    </div>
  );
};

export default PostLaunchSupport;
